import React from 'react';

const FeatureBox = ({ icon, title, description, delay }) => (
  <div className={`col-md-4`}>
    <div className={`feature-box wow fadeIn`} data-wow-delay={delay}>
      <i className={icon}></i>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </div>
);

const FeaturesSection = () => {
  return (
    <section className="section-white section-bottom-border" id="features">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center padding-bottom-10">
            <h2 className="section-title">Amazing Features</h2>
            <p className="section-subtitle">
              InstaApp, which provides amazing business application solutions for customers, will help you boost your business startup with web & mobile app services.
            </p>
          </div>
        </div>
        <div className="row">
          <FeatureBox
            icon="fas fa-list-alt"
            title="Manage Products"
            description="Using the right business application will make your job simpler and save you money over time."
            delay="0s"
          />
          <FeatureBox
            icon="fas fa-chart-line"
            title="Order Monitoring"
            description="Efficiently track and manage orders in real-time with comprehensive order monitoring features embedded within your business."
            delay="0.1s"
          />
          <FeatureBox
            icon="fas fa-bell"
            title="Smart Notifications"
            description="Stay informed and in control with intelligent notifications that provide timely updates and important alerts within your business."
            delay="0.2s"
          />
        </div>
        <div className="row">
          <FeatureBox
            icon="fas fa-hand-holding-usd"
            title="Payment Options"
            description="Streamline financial transactions and enhance customer convenience with diverse payment options."
            delay="0.3s"
          />
          <FeatureBox
            icon="fas fa-rocket"
            title="Web & Mobile App"
            description="According to the needs of the users, we develop both Web and Mobile business apps."
            delay="0.4s"
          />
          <FeatureBox
            icon="fab fa-rocketchat"
            title="Support"
            description="Elevate customer satisfaction and address inquiries seamlessly with robust support features integrated into your application."
            delay="0.5s"
          />
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
